import { Checkbox, Flex, Grid, Radio, RadioGroup, Spacer, Stack, useModal } from '@chakra-ui/react';
import { AuthContext } from 'context/AuthContext';
import { useForm } from 'hooks/useForm';
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { __AllQualifiedUSers } from 'request/configuration/__QualifiedUsers';
import { ButtonStyled } from 'styled/Buttons.styled';
import InputSelect, { InputSelectMulti } from "components/InputSelect/InputSelect";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";

const ExportIntegrationCertificate = ({
  onClose,
  NodeList,
  handleSubmit,
  dafaulActive = [],
  exportFilters,
  exportType,
  setExportType
}) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const [userQualified, setUserQuialified] = useState([]);
  const [selectUserQualified, setSelectUserQualified] = useState(null);
  const [enableQualified, setEnableQualified] = useState(false);
  const [enableDate, setEnableDate] = useState(false);
  const [typeExport, setTypeExport] = useState(0);
  const [fechasHoy, setfechasHoy] = useState(null);
  const [values, handleInputChange, reset, setValues] = useForm({});
  const [form, handleInputChangeForm, resetForm, setForm] = useForm({});

  const getUserQualified = async () => {
    try {
      const res = await __AllQualifiedUSers(token);
      const infoUsuarios = res?.data?.status?.data.map((item) => ({
        value: item?.id,
        label: item?.nit_qualified + " - " + item?.name_qualified
      }));
      setUserQuialified(infoUsuarios);
    } catch (error) { }
  };

  useEffect(() => {
    if (dafaulActive) {
      let objeto = {};
      dafaulActive.forEach((items) => (objeto = { ...objeto, [items]: items }));
      setValues((prev) => ({ ...prev, ...objeto }));
    }
  }, [dafaulActive]);

  const handlePreview = () => {
    const data = {
      type_export: exportType !== undefined ? exportType : 0,
    };
    let obj = {};
    NodeList.forEach(({ name, value }) => (obj = { ...obj, [name]: value }))
    handleSubmit(data, exportType === 2 ? {} : (exportType ? obj : values));
  };

  const selectVar = (e) => {
    const valor = e.target.value;
    setValues({ ...values, [e.target.id]: valor });
  }

  useEffect(() => {
    getUserQualified();
    const hoy_fecha = new Date().toISOString().substring(0, 10);
    setfechasHoy(hoy_fecha);
  }, []);

  return (
    <>
      <RadioGroup defaultValue="Detallado">
        <Stack direction="row">
          <Radio
            type="checkbox"
            value="Detallado"
            checked={exportType === 0}
            onChange={() => setExportType(0)}

          />
          <label style={{ marginRight: '16px' }}>Detallado</label>

          <Radio
            type="checkbox"
            value="General"
            checked={exportType === 1}
            onChange={() => setExportType(1)}
          />
          <label style={{ marginRight: '16px' }}>General</label>

          <Radio
            type="checkbox"
            value="Devoluciones"
            checked={exportType === 2}
            onChange={() => setExportType(2)}
          />
          <label>Devoluciones</label>
        </Stack>
      </RadioGroup>
      {
        exportType === 0 && (
          <>
            <h1 className="mb-3 mt-5">Seleccione las columnas a exportar:</h1>
            <Grid templateColumns="repeat(3, 1fr)"
              gap={1}
              spacing="10px" className='container'>
              {NodeList && NodeList?.map((item, index) => (
                <Checkbox
                  id={item?.name}
                  key={index}
                  value={item?.value}
                  className="ms-1 mb-1 check-box"
                  onChange={selectVar}
                  defaultChecked={
                    dafaulActive &&
                                        dafaulActive.find((element) =>
                                          element === item?.value
                                        )
                  }
                >
                  <span className="name-label">{item?.label}</span>
                </Checkbox>
              ))}
            </Grid>
          </>
        )
      }
      <Flex className="my-3">
        <ButtonStyled bgColor={"#bababa"} onClick={onClose}>
                    Cerrar
        </ButtonStyled>
        <Spacer />
        <ButtonStyled
          bgColor={"#03C39A"}
          type="submit"
          onClick={() => handlePreview()}
          isDisabled={
            (exportType === 0 && values.lenght > 0)
          }
        >
                    Exportar
        </ButtonStyled>
      </Flex>
    </>
  )
}

export default ExportIntegrationCertificate
